<template>
    <div>
        <div class="page-filter-box">
            <el-row :gutter="20">
                <el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="4">                    
					<el-select v-model="params.status"  placeholder="请选择" size="small">
						<el-option value="" label="所有状态"></el-option>
						<el-option label="隐藏" :value="0"></el-option>
						<el-option label="展示" :value="1"></el-option>						
					</el-select>                    
                </el-col>
                <el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="4" class="page-filter-btns">
                    <el-button type="primary" icon="el-icon-search" @click="search" size="small">查询</el-button> 
                    <el-button type="default" icon="el-icon-refresh" @click="reset" size="small">重置</el-button>                   
                </el-col>
            </el-row>
        </div>
        <div class="page-btns-box" v-if="$utils.have('/shoptheme/saveOrUpdate')">
            <el-button
                type="primary"
                icon="el-icon-circle-plus-outline"               
                size="small"
				@click="add"
                >新增主题</el-button
            >
        </div>
        <div class="page-list-box">
            <el-table
                :data="dataList"
                border
                style="width: 100%"
                v-loading="listLoading"
                size="small"
                stripe
            >
                <el-table-column label="主题名称" prop="title" min-width="200" show-overflow-tooltip></el-table-column>
				<el-table-column label="状态">
					<template slot-scope="scope">
                        <el-tag size="mini" :type="scope.row.status == 0 ? 'info' : 'success'">{{ scope.row.status == 0 ?  "隐藏" : "展示"}}</el-tag>
					</template>
				</el-table-column>
				<el-table-column label="序号" prop="sort"></el-table-column>
				<el-table-column label="创建时间" prop="createTime" min-width="150"></el-table-column>
				<el-table-column fixed="right" label="操作" width="170">
					<template slot-scope="scope">
                        <el-button
                            type="text"
                            size="small"
                            icon="el-icon-view"	
                            @click="preview(scope.row)"
                            >预览</el-button>
                        <el-button
                            v-if="$utils.have('/shoptheme/saveOrUpdate')"
                            type="text"
                            size="small"
                            icon="el-icon-edit"
                            @click="edit(scope.row.id)"
                            >编辑</el-button>
						<template v-if="$utils.have('/shoptheme/updateStatus')">
							<el-button
								v-if="scope.row.status == 1"
								type="text"
								size="small"
								icon="el-icon-turn-off"
								@click="editStatus(scope.row.id,0)"
								>隐藏</el-button>
							<el-button
								v-else
								type="text"
								size="small"
								icon="el-icon-turn-off"
								@click="editStatus(scope.row.id,1)"
								>展示</el-button
							>
						</template>
					</template>
					
				</el-table-column>                
            </el-table>
        </div>
        <div v-if="data" class="page-pagination-box">
            <el-pagination
                background
                @size-change="handleSizeChange"
                @current-change="getDataList"
                :current-page.sync="params.pageNo"
                :page-sizes="$pageSizes"
                :page-size.sync="params.pageSize"
                layout="total, sizes, prev, pager, next"
                :total="data.totalCount || 0"
            >
            </el-pagination>
        </div>
        <!-- <edit ref="dataEdit" @update="getDataList" :reFresh="reFresh" ></edit> -->
		<preview ref="dataPreview"></preview>
    </div>
</template>
<script>
//import Edit from './components/edit'
import Preview from '@/components/CodeView';
const defaultParams = {
    pageNo: 1,
    status: '',
}
export default {
    components:{
       // Edit,
        Preview
    },
    data() {
        return {
            data: null,
            dataList: null,
            params: {
                ...defaultParams,
                pageNo:parseInt(this.$route.query.pageNo || 1),
                pageSize: parseInt(this.$route.query.pageSize || this.$pageSizes[0]),
                status:this.$route.query.status ? parseInt(this.$route.query.status) : '',
            },
            detailData: null,
            listLoading: false,
            sswap:process.env.VUE_APP_SSWAP_URL,
			reFresh:false,
        };
    },
    mounted() {
        this.getDataList();
    },
    methods: {
        //获取列表
        getDataList() {
            this.listLoading = true;
            this.$request({
                url: "/shoptheme/list",
                method: "POST",
                data: this.params,
            })
                .then((res) => {
                    const { state, msg, result } = res.data;
                    if (state == 1 && result) {
                        this.data = result;
                        this.dataList = result.result || [];
                    } else {
                        this.$message.error(msg || "请求失败");
                    }
                })
                .catch(() => {
                    this.$message.error("请求错误");
                })
                .finally(() => {
                    this.listLoading = false;
                });
        },
        //选择pageSize
        handleSizeChange(e) {
            this.params.pageNo = 1;
            this.params.pageSize = e;
            this.getDataList();
        },
        //搜索
        search() {
            this.params.pageNo = 1;
            this.getDataList();
        },
        //重置搜索
        reset() {
            this.params = {
                ...defaultParams,
                pageSize: this.params.pageSize
            }
            this.getDataList();
        },
		//改变状态
		editStatus(id,status){
            const _msg = status === 0 ? '确定要隐藏吗?' : '确定要展示吗?';
            this.$confirm(_msg, '提示', {
                type: 'warning',
                center: true,
                closeOnClickModal: false
            }).then(() => {
                this.listLoading = true;
                this.$request({
                    url: '/shoptheme/updateStatus',
                    method: 'POST',
                    params: {id:id,status:status}
                }).then(res => {
                    const { state, msg } = res.data;
                    if( state == 1 ){
                        this.getDataList();
                    }else{
                        this.$message.error(msg || '请求失败');
                    }
                }).catch(() => {
                    this.$message.error('请求错误');
                }).finally(() => {
                    this.listLoading = false;
                });
            })
		},
		//新增事件
		add(){
            this.$router.push('/goodsManage/theme/add');
			this.reFresh = true
		},
		//编辑事件
		edit(id) {
           this.$router.push({
               path:`/goodsManage/theme/edit/${id}`,
               query: {
                   redirect: this.$utils.objArgs(
                       this.$router.currentRoute.path,
                       this.params
                   ),
               },
           });
		},
		preview(item){
             this.$refs.dataPreview.show({
                ...item,
                name:item.title,
				showWechart:0,
                qrCodeUrl:this.sswap+'/pages/goods/theme/theme?id='+item.id
            })
		}
    },
};
</script>
